class GlobalCanvas {
  private defaultWidth: number = 360
  private canvas!: HTMLCanvasElement
  private ctx!: CanvasRenderingContext2D

  constructor(canvas: HTMLCanvasElement) {
    canvas.style.border = '1px solid #999'
    this.canvas = canvas
    const ctx = canvas.getContext('2d')
    if (ctx) this.ctx = ctx
  }

  toString() {
    return this.canvas.toDataURL()
  }
  drawBox(x: number, y: number, size: number) {
    const s = size / 2
    this.ctx.fillStyle = '#fff'
    this.ctx.fillRect(x - s, y - s, size, size)
    this.ctx.beginPath()
    this.ctx.strokeStyle = 'red'
    this.ctx.rect(x - s, y - s, size, size)
    this.ctx.stroke()
  }

  drawImageElm(image: HTMLImageElement, rate = 1) {
    this.canvas.width = this.defaultWidth * rate
    this.canvas.height = (this.defaultWidth * rate * image.height) / image.width
    this.ctx.drawImage(
      image,
      0,
      0,
      this.defaultWidth * rate,
      (this.defaultWidth * rate * image.height) / image.width
    )
  }
  drawImageDataURL(url: string, rate = 1) {
    const image = new Image()
    image.src = url
    image.onload = () => {
      this.canvas.width = this.defaultWidth * rate
      this.canvas.height =
        (this.defaultWidth * rate * image.height) / image.width
      this.ctx.drawImage(
        image,
        0,
        0,
        this.defaultWidth * rate,
        (this.defaultWidth * rate * image.height) / image.width
      )
    }
  }
  drawHistory(
    positions: {
      x: number
      y: number
      size: number
    }[],
    rate = 1
  ) {
    for (let i = 1; i <= positions.length; i++) {
      const { x: x0, y: y0, size: size0 } = positions[i - 1]
      const x = x0 * rate
      const y = y0 * rate
      const size = size0 * rate

      this.ctx.fillStyle = '#fff'
      this.ctx.fillRect(x - size / 2, y - size / 2, size, size)

      this.ctx.textAlign = 'center'
      this.ctx.textBaseline = 'middle'
      this.ctx.font = '18px serif'
      this.ctx.fillStyle = '#00f'
      this.ctx.fillText(i.toString(), x, y)

      this.ctx.beginPath()
      this.ctx.strokeStyle = 'blue'
      this.ctx.rect(x - size / 2, y - size / 2, size, size)
      this.ctx.stroke()
    }
  }
  clearRect() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
  }
}

export default GlobalCanvas
